"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=evm-nft-collection.type.js.map